import React, { useEffect, useState } from "react";
import { Container, Row } from "react-bootstrap";
import { useAuthState } from "react-firebase-hooks/auth";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { auth } from "../../../../../firebase.init";
import MySingleProduct from "../MySingleProduct";

const MyProduct = () => {
  const [user] = useAuthState(auth);
  const url = `https://rocky-ravine-79485.herokuapp.com/my-product?email=${user?.email}`;

  const [myProduct, setMyProduct] = useState([]);

  useEffect(() => {
    try {
      fetch(url, {
        method: "GET",
        headers: {
          authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
        },
      })
        .then((res) =>
          res.status === 403 ? toast('unauthorige') : res.json()
        )
        .then((data) => {
          if (Array.isArray(data)) {
            setMyProduct(data);
          }
        })
    } catch (error) {
      // console.log(error);
    };
  }, [user,localStorage.getItem("token")]);

  const deleteBtn = (id) => {
    const proceed = window.confirm("Are you sure to delete");
    if (proceed) {
      const deleteProduct = `https://rocky-ravine-79485.herokuapp.com/my-product?id=${id}`;
      fetch(deleteProduct, {
        method: "DELETE",
      })
        .then((res) => res.json())
        .then((data) => {
          if (data.deletedCount === 1) {
            const remaining = myProduct.filter((product) => product._id !== id);
            setMyProduct(remaining);
          }
        });
    }
  };
  return (
    <>
      <Container>
        <Row className="my-4">
          <h1>This is my product</h1>
          <br />
          <hr className=" text-success  opacity-50" />
          <br />
          {myProduct?.length === 0 ? (
            <>
              <h5>
                Sorry You don't have{" "}
                <span className="text-danger">product</span>
              </h5>
              <h5>
                Please add a{" "}
                <Link to="/add-product" className="text-success">
                  New Item
                </Link>
              </h5>
            </>
          ) : (
            ""
          )}
          {myProduct.map((product) => (
            <MySingleProduct
              key={product?._id}
              info={product}
              deleteBtn={deleteBtn}
            ></MySingleProduct>
          ))}
        </Row>
      </Container>
    </>
  );
};

export default MyProduct;
